import { render } from "./closed_application_svg.vue?vue&type=template&id=bbba1078"
import script from "./closed_application_svg.vue?vue&type=script&lang=js"
export * from "./closed_application_svg.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\GCTUSMS\\codev1\\apply_online\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__